import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import uris from "../../../config/uris";
import "./style.scss";
import { message, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewMetricsAction, viewMetricsReset } from "../../../store/slices/gemini/view-metrics";
import SpinLoader from "../../../assets/component/loader/loader";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
        LabelList ,
        Legend,
} from "recharts";

const assessmentTypes = [
    { label: "Asset", value: "Asset" },
    { label: "Fund", value: "Fund" },
    { label: "Real Estate", value: "GRESB Real Estate" }
];

const COLORS = ["#139184", "#9E8B5B", "#FAB400", "#549BAD"];
const BarData = [
    { id: 2, key: "GRESB Real Estate", label: "Real Estate", color: "#1F77B4" },
    { id: 0, key: "Asset", label: "Asset", color: "#FF7F0E" },
    { id: 1, key: "Fund", label: "Fund", color: "#2CA02C" },
]
const MetricsView = () => {
    const dispatch = useDispatch();
    const { data: assessmentData, isLoading: assessmentLoading, error: assessmentError } = useSelector(
        (state) => state.viewMetrics
    );
    const [selectedType, setSelectedType] = useState(assessmentTypes[0]?.value);
    const [chartData, setChartData] = useState([]);

    const menuData = {
        title: 'Metrics',
        parentMenu: {
            name: 'View',
            link: uris?.viewMetrics,
        },
        subMenu: {
            name: 'View Metrics',
            link: uris?.viewMetrics,
        },
    };

    const onChangeAssessmentTypes = (e) => { 
        setSelectedType(e);
    };

    useEffect(() => {
        dispatch(viewMetricsReset());
        const payload = { assessmentType: selectedType };
        dispatch(viewMetricsAction(payload));
    }, [selectedType]);

    useEffect(() => {
        const topValue = assessmentData?.entityCount || 0;
        const assessmentTypes = ["Asset", "Fund", "GRESB Real Estate"]
        const keyValue = [
            { key: "entityCount", name: "Entities" },
            { key: "reviewCompleted", name: "Reviewed" },
            { key: "extractionCompleted", name: "Extracted" },
            { key: "publishedCount", name: "Delivered" },


        ]
        const structureChartData = BarData?.map(type => ({
            ...assessmentData?.finalRes[type?.key], name: type?.label
        }))

        const formatedData = keyValue?.map(type => {
            const newObject = { ...type }
            structureChartData?.forEach((item, index) => { newObject[item?.name] = item[type?.key] })
            return newObject
        })
        setChartData(formatedData);
    }, [assessmentData]);

    useEffect(() => {
        if (assessmentError?.message) {
            message.error(assessmentError?.message);
        }
    }, [assessmentError?.message]);

    return (
        <div className="view-metrics-main">
            <Breadcrumbs breadcrumbDetails={menuData} />
        
            <div className="view-metrics-container">
                <div style={{ width: 600, height: 500 }} className="funnel-chart">
                    {assessmentLoading ? (
                        <SpinLoader spin />
                    ) : (
                        <ResponsiveContainer>
                            <BarChart
                                data={chartData}
                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            >
                            <CartesianGrid stroke="transparent" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip
                                    formatter={(value, name) => [value, name]}
                                    cursor={{ fill: "transparent" }}
                                />
                                 <Legend />
                                {BarData?.map(item => (
                                    <Bar
                                        key={item?.id}
                                        dataKey={item?.label}
                                        fill={item?.color}
                                    >
                                        <LabelList
                                            dataKey={item?.label}
                                            position="top"
                                            fill="#000"
                                            fontWeight="bold"
                                        />
                                    </Bar>
                                ))}
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MetricsView;
